export default __webpack_public_path__ + "static/media/vc-quiet-face.c874ab50.png";